module.exports = __webpack_public_path__ + "img/CatchingPokemonOutlined.9c033c9d.svg";